import server from '../../api/server'
// import moment from 'moment'

const state = {
  constant: {
    ACTIVE_SCOPE: 'ACTIVE_SCOPE',
    ALL_SCOPE: 'ALL_SCOPE'
  },
  clients: [],
  chats: [],
  filterContext: {
    search: '',
    scope: '',
    folderName: 0
  },
  chat: {
    prop: {
      id: null,
      name: null
    },
    members: [],
    posts: [],
    loadedPages: 0,
    chatId: null
  },
  postItem: {
    id: null,
    chatId: null,
    clientId: null,
    clientName: null,
    accountId: null,
    accountName: null,
    typeCode: null,
    text: null,
    published: null
  },
  postTypes () {
    return new Map([
      ['CHAT_INVITATION', {caption: 'Приглашение в чат'}],
      ['PLAIN', {caption: 'Сообщение'}],
      ['OFFER', {caption: 'Оферта'}],
      ['ACT', {caption: 'Акт/Накладная'}],
      ['OFFER_CANCEL', {caption: 'Отмена оферты'}],
      ['CLAIM', {caption: 'Претензия'}],
      ['OFFER_REQUEST', {caption: 'Запрос оферты / коммерческого предложения'}],
      ['NOTIFY', {caption: 'Уведомление'}]
    ])
  }
}

// getters
const getters = {
  getChatterChats: state => state.chats,
  getChatterChat: state => state.chat.prop,
  getChatterChatById: state => (id) => {
    return state.chats.find(chat => chat.id === id)
  },
  getChatterPosts: state => state.chat.posts,
  getChatterPostById: state => (id) => {
    return state.chat.posts.find(post => post.id === id)
  },
  getChatterFilterContext: state => state.filterContext,
  getChatterConstant: state => state.constant,
  getPostTypes: state => state.postTypes(),
  getPostTypeByCode: state => (code) => {
    return state.postTypes.get(code)
  }
}

// actions
const actions = {
  fetchChatterChats ({commit, state, getters}) {
    if (getters.getProfileLoaded && (getters.getProfileHaveClient !== true)) {
      return
    }
    server.apiGet(
      '/api/me/chats',
      (data) => {
        commit('setChatterChats', data)
        commit('setSuccessStatus')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка диалогов клиента  '})
      }
    )
  },
  fetchChatterChat ({commit, state, rootState}, id) {
    if (id === 'root') {
      commit('setChatterChat', null)
      return
    }
    server.apiGet(
      '/api/me/chats/' + id,
      (data) => {
        commit('setChatterChat', data)
        commit('setSuccessStatus')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении описания диалога '})
      }
    )
  },

  fetchChatterChatPosts ({commit, state, dispatch}, cxt) {
    if (cxt.chatId === 'root') {
      commit('setChatterChatPosts', null)
      return
    }
    if (state.chat.chatId !== cxt.chatId) {
      commit('setChatterChatPosts', null)
    }
    var page = cxt.force ? 0 : state.chat.loadedPages
    server.apiGetParams(
      '/api/me/chats/' + cxt.chatId + '/posts/',
      {
        size: 20,
        page: page,
        sort: 'id,desc'
      },
      (data) => {
        commit('setChatterChatPosts', {chatId: cxt.chatId, data: data, force: cxt.force})
        commit('setSuccessStatus')
        dispatch('fetchDashboardCounters', null, {root: true})
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка диалогов клиента '})
      }
    )
  },
  fetchChatterPost ({commit, state, rootState}, {chatId, postId}) {
    server.apiGet(
      '/chats/' + chatId + '/posts/' + postId,
      (data) => {
        commit('setSuccessStatus')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении сообщения '})
      }
    )
  },

  addChatterChat ({commit, state, rootState}, item) {
    server.apiPost(
      '/api/me/chats/',
      item,
      (data) => {
        this.dispatch('fetchChatterChats')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при создании диалога '})
      }
    )
  },

  updateChatterChat ({commit, state, rootState}, item) {
    server.apiPost(
      '/api/me/chats/' + item.id,
      item,
      (data) => {
        this.dispatch('fetchChatterChats')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при изменении описания диалога '})
      }
    )
  },
  deleteChatterChat ({commit, state, rootState}, item) {
    server.apiPost(
      '/api/me/chats/' + item.id + '/delete',
      item,
      (data) => {
        this.dispatch('fetchChatterChats')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при удалении (изменении видимости) диалога '})
      }
    )
  },
  addChatterPost ({commit, state, rootState}, item) {
    server.apiPost(
      '/api/me/chats/' + item.chatId + '/posts',
      item,
      (data) => {
        this.dispatch('fetchChatterChatPosts', {chatId: item.chatId, force: true})
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при создании сообщения '})
      }
    )
  },
  setChatterPostAction ({commit, state, rootState}, {item, action}) {
    server.apiPost(
      '/api/me/posts/' + item.id + '/actions',
      action,
      (data) => {
        this.dispatch('fetchChatterChatPosts', {chatId: item.chatId, force: true})
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при изменении статуса сообщения'})
      }
    )
  }
}

// mutations
const mutations = {
  setChatterChats (state, data) {
    state.chats = data
  },
  setChatterChat (state, data) {
    state.chat.prop = data
  },
  setChatterChatPosts (state, cxt) {
    if (!cxt) {
      state.chat.posts = []
      state.chat.loadedPages = 0
      state.chat.chatId = 'root'
    } else {
      cxt.data.content.sort((a, b) => a.id - b.id)
      state.chat.posts = cxt.force ? cxt.data.content : cxt.data.content.concat(state.chat.posts)
      state.chat.loadedPages = cxt.data.totalPages > cxt.data.number ? cxt.data.number + 1 : cxt.data.totalPages
      state.chat.chatId = cxt.chatId
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/chat.js